<script>
export default {
  props: {
    mainClass: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <v-main :class="$style.vMain">
    <header :class="$style.header">
      <BaseLink :to="{ name: 'home' }" :title="$t('gohome')">
        <v-img
          :alt="$t('logoAlt')"
          :class="$style.logoImage"
          contain
          src="@assets/images/logo.png"
          transition="scale-transition"
          width="140"
        />
      </BaseLink>
      <slot name="header"></slot>
    </header>
    <div :class="[$style.main, mainClass]">
      <slot />
    </div>
  </v-main>
</template>

<style lang="scss" module>
@import '@design';

.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: auto;
  background-color: $color-primary;

  @media screen and (min-width: $screen-md) {
    height: calc(100vh - 100px);
  }
}

.logoImage {
  width: 100px;
}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem;
  background-color: $color-primary;

  @media screen and (min-width: $screen-md) {
    height: 100px;
  }

  @media screen and (max-width: $screen-md) {
    flex-wrap: wrap;
  }
}

.vMain {
  background-color: $color-primary;
}
</style>
